import { ReactComponent as TemplateIcon } from "assets/svg/erasGenres.svg";
import { SurveyTemplate } from "../../types";
import { getContestDefaults } from "../helpers";

export const erasAndGenres: SurveyTemplate = {
  icon: <TemplateIcon />,
  title: "Eras & Genres",
  description:
    "Generate a report on the types of music your fans are listening to.",
  templateId: "erasAndGenres",
  template: (v, formState) => ({
    fields: {
      description: {
        content: {
          en: "Eras & Genres",
        },
      },
      ...getContestDefaults(formState),
    },
    ...(formState.hasSweeps === "Yes" && {
      flags: {
        showContestConfirmationMessage: true,
      },
    }),
  }),
  prompt: {
    promptId: (state) =>
      state.hasSweeps === "Yes" ? "pp-marketing-776a95" : "pp-marketing-8014c4",
    fields: [
      {
        name: "hasSweeps",
        type: "radio",
        label: "Will you be offering a sweepstakes prize?",
        options: ["Yes", "No"],
        getValidation: (fields) =>
          !!fields.hasSweeps ? false : "You must select an option.",
      },
      {
        name: "prize",
        type: "text",
        label: "What's the prize?",
        placeholder: "Enter your answer...",
        getValidation: (fields) =>
          fields.prize || fields.hasSweeps === "No"
            ? false
            : "This field cannot be left blank",
        isVisible: (form) => form.hasSweeps === "Yes",
      },
    ],
  },
};
